import { createReducer } from 'redux-starter-kit';
import { VersionAppApi } from '../../_helpers/service';
import { handleError } from '../../utils/handleError';
import i18next from 'i18next';
/**
 * Constants
 */

export const versionPageModule = 'versionApp';
const LOADING = `${versionPageModule}/LOADING`;
const DATA = `${versionPageModule}/DATA`;
const CLEAR_STATE = `${versionPageModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loading: false,
  data: {
    androidVersion: '',
    iosVersion: '',
    isAndroidCritical: false,
    isIosCritical: false
  }
};

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.payload;
  },
  [DATA]: (state, action) => {
    state.data = action.payload;
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const clearState = () => ({ type: CLEAR_STATE });

export const loadData = () => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    const { data } = await VersionAppApi.loadData();
    dispatch({ type: DATA, payload: data.result });
  } catch (error) {
    handleError(error, i18next.t('versionPage_errorLoad'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const setData = data => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    await VersionAppApi.setVersion(data);
  } catch (error) {
    handleError(error, i18next.t('versionPage_errorSet'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};
